import initFavoriteButton from "./product-details-favorite-button/product-details-favorite-button";
import initFavoriteModal from "./product-details-favorite-modal/product-details-favorite-modal";
import initFavoriteErrorModal from "./product-details-favorite-error-modal/product-details-favorite-error-modal";
import initFavoriteSignIn from "./product-details-favorite-sign-in/product-details-favorite-sign-in";
import "./product-details-favorite-icon/product-details-favorite-icon";

export default () => {
  initFavoriteButton();
  initFavoriteModal();
  initFavoriteErrorModal();
  initFavoriteSignIn();
};
